import { useState } from 'react'
import ImageMiniature from './components/ImageMiniature'
import ImagePreview from './components/ImagePreview'
import { galleryPreview } from './constants/gallery'

export default function Gallery() {
    const [opened, setOpened] = useState(false)
    const [index, setIndex] = useState<number | null>(null)

    const handleOpenImage = (index: number) => {
        setOpened(true)
        setIndex(index)
    }

    const handleClosePreview = () => {
        setOpened(false)
        setIndex(null)
    }

    return (
        <div className="w-full grid grid-cols-3 gap-2">
            {galleryPreview.map((item, index) => (
                <ImageMiniature
                    key={index}
                    index={index}
                    src={item.src}
                    alt={item.alt}
                    onClick={handleOpenImage}
                />
            ))}

            {index !== null && (
                <ImagePreview
                    opened={opened}
                    index={index}
                    onCloseClick={handleClosePreview}
                />
            )}
        </div>
    )
}
